





































import {Component, Prop, Vue} from 'vue-property-decorator';
import ServiceContainer from "@flashpointbv/solar-service-container";

@Component({
  name: 'catalog-product-price',
  components: ServiceContainer().getComponents(),
})

export default class extends Vue {
  @Prop() private readonly productData: object;
  @Prop() private readonly position: object;

  private get totalPrices(): object {
    return this.$store.getters['CatalogProduct/totalPrices'] || {};
  }

  private get checkPrice(): boolean {
    return (this.productData['retail_price'] !== this.productData['final_price_incl_tax']) && this.productData['retail_price'] > this.productData['final_price_incl_tax'];
  }

  private get getBigPrice(): void {
    let price = (this.totalPrices['totalPriceInclTax'] || 0).priceFormat();
    return price.split(',')[0];
  }

  private get bundleBackorderable(): boolean {
    return this.productData['product_type'] === 'bundle' && !this.productData['bundle_is_backorder'];
  }

  private get getSmallPrice(): void {
    let price = (this.totalPrices['totalPriceInclTax'] || 0).priceFormat();
    return price.split(',')[1];
  }

  private get getStockMessage(): string {
    return this.productData['delivery_text'] || 'Onbekend';
  }

  private get productDiscount(): number {
    return 100 - Math.round((this.productData['final_price_incl_tax'] / this.productData['retail_price']) * 100);
  }

  private get checkIfOutOfStock(): boolean {
    if (this.productData['product_type'] === 'bundle') {
      return ! this.productData['delivery_in_stock'];
    }
    if (this.productData['product_type'] === 'simple') {
      return this.productData['frontend_stock'] <= 0;
    }
  }
}
